import { type ReactNode } from 'react'

import ReduxProvider from './redux'
import ThemeProvider from './theme'
import AlgoliaProvider from './algolia'
import HydrationProvider from './hydration'
import GlobalModals from '@/components/GlobalModals'

interface Props {
  element: ReactNode
}

export const wrapWithProviders = ({ element }: Props) => {
  return (
    <HydrationProvider>
      <ReduxProvider>
        <AlgoliaProvider>
          <ThemeProvider>
            {element}
            <GlobalModals />
          </ThemeProvider>
        </AlgoliaProvider>
      </ReduxProvider>
    </HydrationProvider>
  )
}
